<template>
  <div class="address-list">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('我的客户列表') }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <div v-if="list.length > 0">
        <van-cell-group
          @click="onSelect"
          class="item-card"
          v-for="item in list"
          inset
          :key="item.PK_ID"
        >
          <van-cell :title="$t('客户名称')" :value="item.name" />
          <van-cell :title="$t('客户编号')" :value="item.sCustNo" />
          <van-cell
            :title="item.memberLevel"
            :value="item.targetPlace"
            :label="item.regChannelName"
          />
        </van-cell-group>
      </div>
      <div v-else>
        <section class="padding no-item">
          <div class=""><img :src="emptyImg" /></div>
          <div class="nodesc">{{ $t('没有相关的信息') }}</div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
import { getMySubCustomerList } from '@/api/cust.js';
import nopic from '@/assets/images/nopic.jpg';
export default {
  data() {
    return {
      list: [],
      loading: false,
      chosenAddressId: '',
      emptyImg: nopic,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onAdd() {
      this.$router.push({ name: 'AddressEdit', query: { mode: 'add' } });
    },
    onEdit(row) {
      this.$router.push({
        name: 'AddressEdit',
        query: { mode: 'edit', ...row },
      });
    },
    onSelect(item) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...item,
        },
      });
    },
    loadData() {
      this.$toast.loading({ duration: 0 });
      getMySubCustomerList({})
        .then(res => {
          if (res.rows.length > 0) {
            this.list = res.rows.map(item => {
              return {
                ...item,
              };
            });
          }
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.page-body {
  margin-bottom: 45px;
  .item-card {
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .no-item {
    text-align: center;
    margin: rem(40px);
    img {
      height: rem(149px);
    }
    .no-desc {
      font-size: rem(13px);
      text-align: center;
    }
  }
}
</style>
